import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Modal, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useState } from "react";
import LoadingApp from "../../../../components/LoadingApp";
import { TermoDeUsoModalProps } from "../../../../interfaces/entities/Reembolso/TermoDeUsoModalProps";
import "./styles.css";
import {
  sxCheckbox,
  sxConfirmTermButton,
  sxError,
  sxOutlinedButton,
  sxTermsOfUseModal,
} from "./sxProps";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";

function TermoDeUsoModal(props: TermoDeUsoModalProps) {
  const [agreed, setAgreed] = useState<boolean>(false);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const handleAgreed = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError(false);
    setAgreed(event.target.checked);
  };

  const handleCloseModal = () => {
    setAgreed(false);
    props.closeTermsOfUse();
  };

  const handleConfirm = async () => {
    if (agreed) {
      props.handleTermsOfUse(true);
    } else {
      setError(true);
    }
  };

  return (
    <div>
      <Modal
        open={props.open}
        onClose={() => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={sxTermsOfUseModal}>
          <div className="terms-of-use-holder">
            <LoadingApp showLoading={showLoading} />
            <div className="terms-of-use-modal-header">
              <h1 className="terms-title">Termo de uso</h1>{" "}
              <button
                className="terms-of-use-modal-header-close"
                aria-label="fechar"
                onClick={handleCloseModal}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="terms-description-holder">
              <div className="terms-description">
                <h1>Sobre o reembolso</h1>
                <p tabIndex={0}>{props.passo1.informativo}</p>
              </div>
            </div>
            <div className="terms-checkbox">
              <FormControlLabel
                control={<Checkbox onChange={handleAgreed} />}
                label="Eu li e concordo com os termos"
                sx={sxCheckbox}
              />
              {error && (
                <div className="terms-of-use-error-holder">
                  <Typography sx={sxError}>
                    Necessário aceitar os termos para seguir
                  </Typography>
                </div>
              )}
            </div>
            <div className="box-terms-of-use-buttons-holder">
              <div className="terms-of-use-buttons">
                <DefaultButton
                  variant="outlined"
                  onClick={handleCloseModal}
                  sx={sxOutlinedButton}
                  fullWidth
                >
                  <Typography style={{ color: "#00995D" }}>CANCELAR</Typography>
                </DefaultButton>
              </div>
              <div className="terms-of-use-buttons">
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleConfirm}
                  sx={sxConfirmTermButton}
                  fullWidth
                  disabled={!agreed}
                >
                  CONFIRMAR
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default TermoDeUsoModal;
